<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('studentHealth.pageTitle') }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('studentHealth.pageTitle'),
            href: '/student-healths'
          },
          {
            text: $t('add_new'),
            active: true
          }
        ]"
      />
    </div>
    <div class="row">
      <div class="col-lg-12">
        <ts-loading-banner :loading="loading">
          <ts-card>
            <ts-card-wrapper>
              <form class="form-horizontal">
                <div class="row mb-3">
                  <div class="col-sm-12 col-lg-7 col-md-6">
                    <div class="form-group row">
                      <label
                        class="col-md-4 form-col-label control-label required"
                        >{{ $t('studentHealth.studentName') }}</label
                      >
                      <div class="col-md-8">
                        <ts-select-student
                          v-model.number="model.student_id"
                          @change="setStudentInputValue"
                        />
                        <div class="validate" v-if="errors.has('student_id')">
                          {{ errors.first('student_id') }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-sm-5">
                    <div class="row">
                      <div
                        class="col-sm-6 mb-3"
                        v-for="(category, index) in healthCategories"
                        :key="index"
                      >
                        <h5>
                          <b class="text-primary">
                            &bull; {{ category.health_category_description }}</b
                          >
                        </h5>
                        <div
                          class="row"
                          v-for="(item, index) in model.health_items_list[
                            index
                          ]"
                          :key="index"
                        >
                          <div class="col-sm-12">
                            <ts-checkbox v-model="item.health_item_selected">{{
                              item.health_item_description
                            }}</ts-checkbox>
                            <textarea
                              v-model="item.health_item_remark"
                              v-if="
                                item.has_comment == 1 &&
                                item.health_item_selected == true
                              "
                              cols="30"
                              rows="2"
                              class="form-control mt-1"
                              placeholder="Write comment here..."
                            ></textarea>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-7">
                    <h5><b class="text-primary">Prefer Hospital</b></h5>
                    <table class="table table-bordered">
                      <thead>
                        <tr>
                          <th width="4%" class="text-center">No</th>
                          <th width="30%">Hospital Name</th>
                          <th width="30%">Contact Number</th>
                          <th width="25%">Address</th>
                          <th width="15%">Order</th>
                          <th class="text-center" width="2%">
                            <a
                              href="#"
                              class="btn btn-xs btn-primary"
                              @click.prevent="addMoreHospitalRows"
                              :disabled="!model.student_id"
                              ><i class="fas fa-plus"></i
                            ></a>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(hospital, index) in model.prefer_hospitals"
                          :key="index"
                        >
                          <td
                            class="text-center"
                            style="vertical-align: middle"
                          >
                            {{ hospital.display_order }}
                          </td>
                          <td>
                            <select
                              v-model="hospital.hospital_name"
                              class="form-control"
                              @change="onProfileChange(hospital)"
                            >
                              <option
                                v-for="(
                                  hospitalProfile, index
                                ) in productNotIncludeSelected({
                                  addedProducts: model.prefer_hospitals,
                                  excludeProductId: hospital.hospital_name
                                }).map(el => ({
                                  value: el.hospital_name,
                                  label: el.hospital_name
                                }))"
                                :key="index"
                                :value="hospitalProfile.value"
                              >
                                {{ hospitalProfile.label }}
                              </option>
                            </select>
                            <div
                              class="invalid-feedback"
                              v-if="
                                errors.has(
                                  'prefer_hospitals.' + index + '.hospital_name'
                                )
                              "
                            >
                              {{
                                errors.first(
                                  'prefer_hospitals.' + index + '.hospital_name'
                                )
                              }}
                            </div>
                          </td>
                          <td>
                            <input
                              v-model="hospital.contact_number"
                              type="text"
                              class="form-control"
                              :class="{
                                'is-invalid': errors.has(
                                  'prefer_hospitals.' +
                                    index +
                                    '.contact_number'
                                )
                              }"
                            />
                            <div
                              class="invalid-feedback"
                              v-if="
                                errors.has(
                                  'prefer_hospitals.' +
                                    index +
                                    '.contact_number'
                                )
                              "
                            >
                              {{
                                errors.first(
                                  'prefer_hospitals.' +
                                    index +
                                    '.contact_number'
                                )
                              }}
                            </div>
                          </td>
                          <td>
                            <input
                              v-model="hospital.address"
                              type="text"
                              class="form-control"
                              :class="{
                                'is-invalid': errors.has(
                                  'prefer_hospitals.' + index + '.address'
                                )
                              }"
                            />
                            <div
                              class="invalid-feedback"
                              v-if="
                                errors.has(
                                  'prefer_hospitals.' + index + '.address'
                                )
                              "
                            >
                              {{
                                errors.first(
                                  'prefer_hospitals.' + index + '.address'
                                )
                              }}
                            </div>
                          </td>
                          <td>
                            <input
                              v-model="hospital.display_order"
                              type="text"
                              class="form-control"
                              :class="{
                                'is-invalid': errors.has(
                                  'prefer_hospitals.' + index + '.display_order'
                                )
                              }"
                            />
                            {{
                              errors.first(
                                'prefer_hospitals.' + index + '.display_order'
                              )
                            }}
                          </td>
                          <td class="text-center">
                            <a
                              href="#"
                              @click.prevent="removeHospital(hospital)"
                            >
                              <i
                                class="fas fa-trash-alt text-red"
                                title="delete"
                              ></i>
                            </a>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <hr />
                <div class="row">
                  <div class="col-sm-12">
                    <h5><b class="text-primary">Health History</b></h5>
                    <table class="table table-bordered">
                      <thead>
                        <tr>
                          <th rowspan="3" style="width: 10%">Date</th>
                          <th rowspan="3" style="width: 10%">Academin Year</th>
                          <th rowspan="3" style="width: 10%">Academic Term</th>
                          <th rowspan="3" style="width: 10%">Sub Program</th>
                          <th rowspan="3" style="width: 10%">Academic Grade</th>
                        </tr>
                        <tr>
                          <th colspan="5" class="text-center">Health Record</th>
                          <th rowspan="2" class="text-center">
                            <a
                              href="#"
                              class="btn btn-xs btn-primary"
                              @click.prevent="addMoreHistoryRows"
                              :disabled="!model.student_id"
                              ><i class="fas fa-plus"></i
                            ></a>
                          </th>
                        </tr>
                        <tr>
                          <th class="text-center">Height</th>
                          <th class="text-center">Weight</th>
                          <th class="text-center">Sickness Record</th>
                          <th class="text-center">Important Info</th>
                          <th class="text-center">Solution</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(history, index) in model.health_history"
                          :key="index"
                        >
                          <td>
                            <ts-date-picker-input
                              v-model="history.history_date"
                            />
                            <div
                              class="validate"
                              v-if="
                                errors.has(
                                  'health_history.' + index + '.history_date'
                                )
                              "
                            >
                              {{
                                errors.first(
                                  'health_history.' + index + '.history_date'
                                )
                              }}
                            </div>
                          </td>

                          <td>
                            <select
                              v-model="history.ac_year_id"
                              class="form-control"
                              :class="{
                                'is-invalid': errors.has(
                                  'health_history.' + index + '.ac_year_id'
                                )
                              }"
                              @change="
                                () =>
                                  (history.ac_term_id =
                                    history.acps_id =
                                    history.grade_id =
                                      '')
                              "
                            >
                              <option
                                v-for="(program, id) in programs"
                                :key="id"
                                :value="program.ac_year_id"
                              >
                                {{ program.ac_year }}
                              </option>
                            </select>
                            <div
                              class="invalid-feedback"
                              v-if="
                                errors.has(
                                  'health_history.' + index + '.ac_year_id'
                                )
                              "
                            >
                              {{
                                errors.first(
                                  'health_history.' + index + '.ac_year_id'
                                )
                              }}
                            </div>
                          </td>
                          <td>
                            <select
                              v-model="history.ac_term_id"
                              class="form-control"
                              :class="{
                                'is-invalid': errors.has(
                                  'health_history.' + index + '.ac_term_id'
                                )
                              }"
                              @change="
                                () => (history.acps_id = history.grade_id = '')
                              "
                            >
                              <option
                                v-for="(program, id) in getTermByYearGetter(
                                  history.ac_year_id
                                )"
                                :key="id"
                                :value="program.ac_term_id"
                              >
                                {{ program.term_name }}
                              </option>
                            </select>
                            <div
                              class="invalid-feedback"
                              v-if="
                                errors.has(
                                  'health_history.' + index + '.ac_term_id'
                                )
                              "
                            >
                              {{
                                errors.first(
                                  'health_history.' + index + '.ac_term_id'
                                )
                              }}
                            </div>
                          </td>
                          <td>
                            <select
                              v-model="history.acps_id"
                              class="form-control"
                              :class="{
                                'is-invalid': errors.has(
                                  'health_history.' + index + '.acps_id'
                                )
                              }"
                              @change="() => (history.grade_id = '')"
                            >
                              <option
                                v-for="(
                                  program, id
                                ) in getSubProgramByTermGetter(
                                  history.ac_term_id
                                )"
                                :key="id"
                                :value="program.acps_id"
                              >
                                {{ program.acps_name_foreign }}
                              </option>
                            </select>
                            <div
                              class="invalid-feedback"
                              v-if="
                                errors.has(
                                  'health_history.' + index + '.acps_id'
                                )
                              "
                            >
                              {{
                                errors.first(
                                  'health_history.' + index + '.acps_id'
                                )
                              }}
                            </div>
                          </td>
                          <td>
                            <select
                              v-model="history.grade_id"
                              class="form-control"
                              :class="{
                                'is-invalid': errors.has(
                                  'health_history.' + index + '.grade_id'
                                )
                              }"
                            >
                              <option
                                v-for="(
                                  program, id
                                ) in getGradeBySubProgramGetter(
                                  history.acps_id
                                )"
                                :key="id"
                                :value="program.grade_id"
                              >
                                {{ program.grade_name_foreign }}
                              </option>
                            </select>
                            <div
                              class="invalid-feedback"
                              v-if="
                                errors.has(
                                  'health_history.' + index + '.grade_id'
                                )
                              "
                            >
                              {{
                                errors.first(
                                  'health_history.' + index + '.grade_id'
                                )
                              }}
                            </div>
                          </td>
                          <td style="width: 6%">
                            <input
                              v-model="history.tall"
                              type="number"
                              step="any"
                              class="form-control text-center"
                              min="0"
                              :class="{
                                'is-invalid': errors.has(
                                  'health_history.' + index + '.tall'
                                )
                              }"
                            />
                            <div
                              class="invalid-feedback"
                              v-if="
                                errors.has('health_history.' + index + '.tall')
                              "
                            >
                              {{
                                errors.first(
                                  'health_history.' + index + '.tall'
                                )
                              }}
                            </div>
                          </td>
                          <td style="width: 6%">
                            <input
                              v-model="history.weight"
                              type="number"
                              step="any"
                              class="form-control text-center"
                              min="0"
                              :class="{
                                'is-invalid': errors.has(
                                  'health_history.' + index + '.weight'
                                )
                              }"
                            />
                            <div
                              class="invalid-feedback"
                              v-if="
                                errors.has(
                                  'health_history.' + index + '.weight'
                                )
                              "
                            >
                              {{
                                errors.first(
                                  'health_history.' + index + '.weight'
                                )
                              }}
                            </div>
                          </td>
                          <td>
                            <input
                              v-model="history.sickness_record"
                              type="text"
                              step="any"
                              class="form-control text-center"
                              min="1"
                              :class="{
                                'is-invalid': errors.has(
                                  'health_history.' + index + '.sickness_record'
                                )
                              }"
                            />
                            <div
                              class="invalid-feedback"
                              v-if="
                                errors.has(
                                  'health_history.' + index + '.sickness_record'
                                )
                              "
                            >
                              {{
                                errors.first(
                                  'health_history.' + index + '.sickness_record'
                                )
                              }}
                            </div>
                          </td>
                          <td>
                            <input
                              v-model="history.important_info"
                              type="text"
                              step="any"
                              class="form-control text-center"
                              min="1"
                              :class="{
                                'is-invalid': errors.has(
                                  'health_history.' + index + '.important_info'
                                )
                              }"
                            />
                            <div
                              class="invalid-feedback"
                              v-if="
                                errors.has(
                                  'health_history.' + index + '.important_info'
                                )
                              "
                            >
                              {{
                                errors.first(
                                  'health_history.' + index + '.important_info'
                                )
                              }}
                            </div>
                          </td>
                          <td>
                            <input
                              v-model="history.solution"
                              type="text"
                              step="any"
                              class="form-control text-center"
                              min="1"
                              :class="{
                                'is-invalid': errors.has(
                                  'health_history.' + index + '.solution'
                                )
                              }"
                            />
                            <div
                              class="invalid-feedback"
                              v-if="
                                errors.has(
                                  'health_history.' + index + '.solution'
                                )
                              "
                            >
                              {{
                                errors.first(
                                  'health_history.' + index + '.solution'
                                )
                              }}
                            </div>
                          </td>
                          <td class="text-center">
                            <a href="#" @click.prevent="removerRow(history)">
                              <i
                                class="fas fa-trash-alt text-red"
                                title="delete"
                              ></i>
                            </a>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12 text-right">
                    <ts-button
                      color="primary"
                      @click.prevent="save"
                      :waiting="waiting"
                    >
                      {{ $t('save') }}
                    </ts-button>
                  </div>
                </div>
              </form>
            </ts-card-wrapper>
          </ts-card>
        </ts-loading-banner>
      </div>
    </div>
  </div>
</template>
<script>
import { Errors } from 'form-backend-validation'
import TsSelectStudent from '@/components/SelectStudent'
import { mapActions, mapGetters, mapState } from 'vuex'
import moment from 'moment'
export default {
  name: 'student-health-create',
  components: { TsSelectStudent },
  data () {
    return {
      model: {
        student_id: '',
        health_items_list: [],
        health_history: [],
        prefer_hospitals: []
      },
      rows: {
        history_date: moment().format('DD-MM-YYYY'),
        ac_year_id: '',
        ac_term_id: '',
        acps_id: '',
        grade_id: '',
        tall: '',
        weight: '',
        sickness_record: '',
        important_info: '',
        solution: ''
      },
      errors: new Errors(),
      loading: false,
      waiting: false,
      saving_new: false
    }
  },
  created () {
    this.getHospitalProfile()
  },
  computed: {
    ...mapGetters('studentHealth', [
      'getTermByYearGetter',
      'getSubProgramByTermGetter',
      'getGradeBySubProgramGetter',
      'productNotIncludeSelected',
      'hospitalProfile'
    ]),
    ...mapState('studentHealth', [
      'healthCategories',
      'programs',
      'hospitalProfiles'
    ])
  },
  methods: {
    ...mapActions('studentHealth', [
      'dataBeforeCreate',
      'getProgramByStudent',
      'find',
      'getHospitalProfile'
    ]),
    async fetchResource () {
      this.loading = true
      await this.dataBeforeCreate()
        .then(() => {
          this.loading = false
          this.setItemList()
        })
        .catch(error => {
          this.loading = false
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
    },
    setItemList () {
      this.healthCategories.map((value, key) => {
        this.model.health_items_list.push(value.health_items)
      })
    },
    filterItemHasSelected () {
      var item = []
      this.model.health_items_list.map((value, key) => {
        if (value.filter(s => s.health_item_selected == true).length > 0) {
          item.push(...value.filter(s => s.health_item_selected == true))
        }
      })

      return item
    },

    clearCheckBox () {
      this.model.health_items_list.map((value, main_key) => {
        value.map((el, sub_key) => {
          delete this.model.health_items_list[main_key][sub_key]
            .health_item_selected
          if (
            this.model.health_items_list[main_key][sub_key].has_comment == 1
          ) {
            delete this.model.health_items_list[main_key][sub_key]
              .health_item_remark
          }
        })
      })
    },

    setCheckBox (item) {
      this.model.health_items_list.map((value, main_key) => {
        value.map((el, sub_key) => {
          item.map(el_chil => {
            if (
              el_chil.is_selected == 1 &&
              // el_chil.health_item.health_category_id == el.health_category_id &&
              el_chil.health_item_id == el.health_item_id
            ) {
              this.model.health_items_list[main_key][
                sub_key
              ].health_item_selected = true

              if (
                this.model.health_items_list[main_key][sub_key].has_comment == 1
              ) {
                this.model.health_items_list[main_key][
                  sub_key
                ].health_item_remark = el_chil.health_remark
              }
            }
          })
        })
      })
    },
    addMoreHistoryRows () {
      this.loading = true
      this.getProgramByStudent(this.model.student_id)
        .then(() => {
          if (this.programs.length > 0) {
            this.rows = {
              history_date: moment().format('DD-MM-YYYY'),
              ac_year_id: this.programs[0].ac_year_id,
              ac_term_id: this.programs[0].ac_term_id,
              acps_id: this.programs[0].acps_id,
              grade_id: this.programs[0].grade_id,
              tall: '',
              weight: '',
              sickness_record: '',
              important_info: '',
              solution: ''
            }
          }
          this.model.health_history.push(Object.assign({}, this.rows))
        })
        .finally(() => {
          this.loading = false
        })
    },

    removerRow (record) {
      this.model.health_history.splice(
        this.model.health_history.indexOf(record),
        1
      )
    },
    addMoreHospitalRows () {
      this.model.prefer_hospitals.push(
        Object.assign(
          {},
          {
            id: 0,
            hospital_name: '',
            contact_number: '',
            address: '',
            display_order: this.model.prefer_hospitals.length + 1
          }
        )
      )
    },

    removeHospital (record) {
      this.model.prefer_hospitals.splice(
        this.model.prefer_hospitals.indexOf(record),
        1
      )
    },

    pushItemHistory (item) {
      this.model.health_history = []
      item.map((value, key) => {
        this.model.health_history.push(value)
      })
    },
    pushPreferHospital (item) {
      this.model.prefer_hospitals = []
      item.map((value, key) => {
        this.model.prefer_hospitals.push(value)
      })
    },
    save () {
      let data_sent = {}
      let result = this.filterItemHasSelected()
      data_sent.health_list = result
      data_sent.student_id = this.model.student_id
      data_sent.health_history = this.model.health_history
      data_sent.prefer_hospitals = this.model.prefer_hospitals
      if (data_sent.health_list.length == 0) {
        this.$toasted.error('No item selected. Please try again!')
        throw 'validation fail....'
      }
      this.errors = new Errors()
      this.waiting = true

      this.$store
        .dispatch('studentHealth/store', data_sent)
        .then(response => {
          this.clearCheckBox()
          this.model.student_id = ''
          this.model.health_history = []
          this.model.prefer_hospitals = []
          this.waiting = false
          this.$toasted.success(response.message)
          this.$router.push({ name: 'student-health' })
        })
        .catch(error => {
          this.waiting = false
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
    },
    onSubProgramChange (record, index) {
      this.clearFilterLevelAndTerm(index)
    },

    clearFilterLevelAndTerm (index) {
      this.model.health_history[index].ac_term_id = ''
      this.model.health_history[index].ac_year_id = ''
    },
    setStudentInputValue (student_id) {
      this.model.student_id = student_id
    },
    onProfileChange (hospital) {
      let findHospitalByName = this.hospitalProfiles.find(
        h => h.hospital_name == hospital.hospital_name
      )
      hospital.contact_number = findHospitalByName.contact_number
      hospital.address = findHospitalByName.address
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.fetchResource()
    })
  },
  beforeRouteLeave (to, from, next) {
    if (_.isEmpty(to.params) && to.name != 'student-health') {
      this.$store.commit('studentHealth/SET_HEALTH_CATEGORIES', [])
      this.$store.commit('studentHealth/SET_PROGRAMS', [])
    }
    next()
  },
  watch: {
    'model.student_id': function (val) {
      if (val) {
        this.loading = true
        this.find(val).then(async response => {
          await this.getProgramByStudent(val)
          this.clearCheckBox()
          this.pushItemHistory(response.health_history)
          this.pushPreferHospital(response.prefer_hospitals)
          this.setCheckBox(response.health_list)
          this.loading = false
        })
      }
    }
  }
}
</script>
<style>
.table th,
td {
  padding: 4px !important;
}
</style>
